export var GAMES = {
  newmatgo: {
    key: 'newmatgo',
    name: '뉴맞고',
    ssn: 154,
    gameInfoSrl: 1
  },
  matgo: {
    key: 'matgo',
    name: '맞고',
    ssn: 154,
    gameInfoSrl: 3
  },
  gostop: {
    key: 'gostop',
    name: '고스톱',
    ssn: 154,
    gameInfoSrl: 4
  }
};

export var LINKS = {
  closeWebview: 'npsusl://onWebviewClose',

  /** 피망캐쉬 충전 */
  rechargePmangCashPrefix: '//board.pmang.com',

  /** 초과머니 팝업 */
  extMoneyPopup: '//board.pmang.com/pmang_extmoney_alert.nwz',

  /** 1:1 문의 */
  oneToOneInquiry: '//helpdesk.pmang.com/inquiry/oneToOneInquiry.do',

  /** 보안 SMS 해지 */
  unregisterSecureSms: '//board.pmang.com/help_top.nwz?cat1=7_5_3',

  /** 개인암호 */
  changePersonalPassword: '//board.pmang.com/help_top.nwz?cat1=7_7_3',
  unregisterPersonalPassword: '//board.pmang.com/help_top.nwz?cat1=7_7_4',

  /** 피망캐쉬 선물하기 */
  pmangCashPresent: '//board.pmang.com/pmang_webgame_purchase.nwz',

  /** 마이피망 > 계좌정보 */
  myPayment: '//www.pmang.com/my_point_info.nwz'
};

export var FCM = {
  firebaseConfig: {
    apiKey: 'AIzaSyDhJ0ebmQQZKPxN4W5riBUrrNB0085Ai24',
    authDomain: 'web-board-push.firebaseapp.com',
    projectId: 'web-board-push',
    storageBucket: 'web-board-push.appspot.com',
    messagingSenderId: '46046713521',
    appId: '1:46046713521:web:cc79ab4fe02e9011b23490',
    measurementId: 'G-05HWZF62X8'
  },
  fcmOptions: {
    firebaseVapidKey:
      'BNlsPdj672bQc_zDJ_Pi_lYh9Zgt4nVePOqIy2l5TDeR6hnvjzuFF-FAKVswY7FnrZACxd67huh7buBFrtWHdyE',
    apiEndpoint: '/api/fcm',
    storageKeySuffix: 'fcm',
    topicPrefix: {
      newmatgo: 'GOSTOP_USERS',
      matgo: 'GOSTOP_USERS',
      gostop: 'GOSTOP_USERS'
    }
  }
};
